<template>
  <v-flex lg3 md4 sm6 xs6 style="padding: 5px" v-if="loading || data !== null">
    <v-skeleton-loader
      v-if="loading"
      type="card"
      height="100"
    ></v-skeleton-loader>
    <v-card v-else>
      <v-card-title style="text-align: center;display:block;">
        <i :class="'fad fa-' + icon"></i><br>
        <p style="white-space: nowrap;margin-bottom:0px;">{{ data }}</p>
      </v-card-title>
      <v-card-subtitle style="text-align:center;">{{ name }}</v-card-subtitle>
    </v-card>
  </v-flex>
</template>

<script>
export default {
  props: {
    data: {
      type: [String, Number],
      required: false,
      default: null,
    },
    name: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    }
  },
};
</script>

<style>
</style>